module.exports = __webpack_public_path__ + "static/media/pill-icon-livechat.89ab512d.svg";